// Auto-generated by scripts/generate-version.js - do not edit
export default '1.0-389';
